import ServiceCard from "./ServiceCard";
import { useSiteContent } from "../../../context/SiteContentContext";

export default function ControlsSection() {
  const { content } = useSiteContent();
  const services = content.services_controls;
  return (
    <section id="control" className="w-full relative overflow-hidden" style={{ background: "#f7fbff" }}>
      {/* Top image banner */}
      <div className="w-full relative overflow-hidden" style={{ height: "280px" }}>
        <img
          src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1600&h=560&fit=crop&q=85"
          alt="Controls & Automation"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom,rgba(247,251,255,0) 0%,rgba(247,251,255,0.3) 60%,rgba(247,251,255,1) 100%)" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(105deg,rgba(13,40,80,0.55) 0%,transparent 60%)" }} />
        {/* Overlay text on image */}
        <div className="absolute bottom-8 left-8 md:left-16">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-3"
            style={{ background: "rgba(74,159,212,0.3)", color: "#fff", border: "1px solid rgba(74,159,212,0.5)", backdropFilter: "blur(8px)" }}
          >
            <i className="ri-settings-3-line"></i>
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
            Controls &amp; <span style={{ color: "#7dd3fc" }}>Automation</span>
          </h2>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-8 pb-24 pt-16">
        {/* Sub-header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-10 gap-4 pt-4">
          <p className="text-gray-500 max-w-lg text-sm leading-relaxed">
            Advanced building control systems trusted by NYC's top commercial and residential properties. From booster pumps to smart integrations — we handle it all.
          </p>
          <a
            href="#easy"
            onClick={(e) => { e.preventDefault(); document.querySelector("#easy")?.scrollIntoView({ behavior: "smooth" }); }}
            className="flex items-center gap-2 text-sm font-bold whitespace-nowrap cursor-pointer transition-all hover:gap-3"
            style={{ color: "#4a9fd4" }}
          >
            Get a quote <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {services.map((s) => (
            <ServiceCard key={s.title} {...s} variant="light" />
          ))}
        </div>
      </div>
    </section>
  );
}
